var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPoll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2ec5ce",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 100.00 100.00",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(50,50), scale(0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.4
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76,20H24c-2.2,0-4,1.8-4,4v8c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-8C80,21.8,78.2,20,76,20z M51,32v-8h25 l0,8H51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76,42H24c-2.2,0-4,1.8-4,4v8c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-8C80,43.8,78.2,42,76,42z M42,54v-8h34 l0,8H42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76,64H24c-2.2,0-4,1.8-4,4v8c0,2.2,1.8,4,4,4h52c2.2,0,4-1.8,4-4v-8C80,65.8,78.2,64,76,64z M60,76v-8h16 l0,8H60z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPoll);
export default __webpack_public_path__ + "static/media/CustomPoll.6687dbaa14d12a37a84207beb2731983.svg";
export { ForwardRef as ReactComponent };